define.alias("shared/components/shared/ui/accordion-item", "media/components/shared/ui/accordion-item");